import React, { useEffect, useState } from "react";
import "./App.css";
import axios from "axios";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import PromoPage from "./pages/PromoPage";
import NormalPage from "./pages/NormalPage";
import AdminPage from "./pages/AdminPage";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// Homepage renders whichever variant the admin activated (default: promo).
function HomeRouter() {
  const [variant, setVariant] = useState(null);
  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/site/config`)
      .then((res) => {
        if (!cancelled) setVariant(res.data?.home_variant === "classique" ? "classique" : "promo");
      })
      .catch(() => {
        if (!cancelled) setVariant("promo");
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (variant === null) {
    return (
      <div className="min-h-screen ocean-bg flex items-center justify-center">
        <div className="w-10 h-10 rounded-full border-2 border-white/20 border-t-[#f6e3a8] animate-spin" />
      </div>
    );
  }
  return variant === "classique" ? <NormalPage /> : <PromoPage />;
}

function App() {
  // Static build mode: one page per build (for the WordPress plugin).
  // Set REACT_APP_PAGE=promo or REACT_APP_PAGE=classique at build time.
  const staticPage = process.env.REACT_APP_PAGE;
  if (staticPage === "promo" || staticPage === "classique") {
    return (
      <div className="App">
        {staticPage === "classique" ? <NormalPage /> : <PromoPage />}
      </div>
    );
  }

  // Live/preview mode: full router with admin-controlled homepage.
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomeRouter />} />
          <Route path="/promo" element={<PromoPage />} />
          <Route path="/classique" element={<NormalPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
